import { RefinementList } from 'react-instantsearch-dom'

export default function Features() {
    return (
        <div className="mb36">
            <div className="ais-Heading mb18">Išskirtinumai</div>
            <RefinementList attribute="all_features" limit={100} />
        </div>
    )
}
